<template>
  <div>
    <spinner-loader :loading="loading" />
    <campaign-form
      v-if="!loading"
      :campaign="campaign"
      :disabled="true"
    />
  </div>
</template>

<script>
import CampaignForm from '@/components/Marketing/CampaignForm.vue'
import Campaigns from '@/compositions/Campaigns/CampaignsAPI'
import SpinnerLoader from '@/components/Table/SpinnerLoader.vue'

export default {
  name: 'EditCampaign',
  components: { CampaignForm, SpinnerLoader },
  data() {
    return {
      loading: false,
    }
  },
  setup() {
    const {
      campaign, showRequest,
    } = Campaigns()
    return {
      campaign, showRequest,
    }
  },
  created() {
    this.getCampaign()
  },
  methods: {
    getCampaign() {
      this.loading = true
      this.showRequest(this.$route.params.id, { embed: 'header' }).then(res => {
        this.campaign = { ...res.data.data, attendees: res.data.data.emails?.map(email => ({ email })), events: res.data.data.events.map(event => ({ ...event, title: event.title.en })) }
      }).finally(() => {
        this.loading = false
      })
    },
    editCampaign() {
      return this.updateRequest().then(() => {
      })
    },
    sendCampaign() {
      return this.sendRequest().then(() => {
      })
    },
  },
}
</script>

<style>

</style>
